import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { customShowLoadingLayer,customHideLoadingLayer,showWarningLayer, hideWarningLayer,validateEmail, useFocus } from '../../utils/utils';
import NavBar from '../../components/home/navbar/navbar.component';
import FooterNew from '../../components/footernew/footernew.component';

import { ProjectActionTypes } from '../../redux/project/project.types';
import { LoginActionTypes } from '../../redux/login/login.types';
import * as actionCreators from '../../redux/login/login.actions';
import * as actionDefinitionCreators from '../../redux/definitions/definitions.actions';
import './giris.styles.scss';

const GirisPage = () => {
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  let history = useHistory();
  
  const [emailRef, setEmailFocus] = useFocus();
  const [passwordRef, setPasswordFocus] = useFocus();
  //const [loginRef, setLoginFocus] = useFocus();
  const loginFormType = "user";
  const [username,setUsername] = useState("");
  const [password, setPassword] = useState("");
  
  const handleChangeUsername = (e) => setUsername(e.target.value);
  const handleChangePassword = (e) => setPassword(e.target.value);

  const onWarning = (payload) => {
    dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload});
  }

  const onSuccess = (loginData) => {
    dispatch({ type: LoginActionTypes.LOGIN_SUCCESS, loginData: loginData});
  }


  const login = async (goToMessage) => {
    customShowLoadingLayer();  
    let warnmessage = "";
   
    if (username === "" || username === undefined || username === null ){
      warnmessage = xprops.project.language.keywords.lutfenEpostaAdresiniKontrolEdin;
      onWarning({warningMessageType:'fail', warningMessageText: warnmessage});      
      showWarningLayer();
      setEmailFocus();
      customHideLoadingLayer();      
      return;    
    }else{
      if (!validateEmail(username)){
        warnmessage = xprops.project.language.keywords.lutfenEpostaAdresiniKontrolEdin;
        onWarning({warningMessageType:'fail', warningMessageText: warnmessage});      
        showWarningLayer();
        setEmailFocus();
        customHideLoadingLayer();      
        return;        
      }
    }    

    if (password === "" || password === undefined || password === null ){
      warnmessage = xprops.project.language.keywords.lutfenSifreAlaniniKontrolEdin;
      onWarning({warningMessageType:'fail', warningMessageText: warnmessage});      
      showWarningLayer();
      setPasswordFocus();
      customHideLoadingLayer();      
      return;    
    }

    const fmData = new FormData();
    fmData.append("username", username);
    fmData.append("password", password);
    fmData.append("utype",loginFormType);
    const config = {
      headers: { "content-type": "multipart/form-data" },
      crossDomain: true
    }
    const loginResult = await axios.post(`https://www.sensizolmazsessizolmaz.org/html/do_actionlogin.php`,
          fmData,
          config);

    if (loginResult.data.type === "success"){
      customShowLoadingLayer();
      onSuccess(loginResult.data.data);
      warnmessage = xprops.project.language.keywords.girisYapildi;
      if (xprops.login.chatMessageAfterLogin === true){
        dispatch(actionDefinitionCreators.setFormChatStatus(true));
        dispatch(actionCreators.setChatMessageAfterLogin(false));
      }
      onWarning({warningMessageType:'success', warningMessageText: warnmessage});      
      showWarningLayer();
      history.push('/');
      history.replace(xprops.project.language.routes.home);
    }else{
      onWarning({warningMessageType:'fail', warningMessageText: xprops.project.language.keywords.kullaniciAdiVeyaSifreKontrol});
      showWarningLayer();
      customHideLoadingLayer();
    }    
    customHideLoadingLayer();
  }

  useEffect(() =>{
    window.scrollTo(0, 0);
  },[]);    

  return(
    <React.Fragment>
      <div className="homeWrapper">
        <NavBar menutype="nosticky" />      
        <div className="newSectionWrapper">
          <div className="newContentWrapper">
            <div className="loginContentWrapper">
              <div className="loginSection">
                <h4 className="login-label">{xprops.project.language.keywords.epostaAdresi} :</h4>
                <input ref={emailRef} type="text" placeholder={xprops.project.language.keywords.lutfenEpostaAdresiniGiriniz} className="edits-login" value={username} onChange={handleChangeUsername} onKeyPress={(e)=> e.key === 'Enter' && setPasswordFocus()} />
                <h4 className="login-label">{xprops.project.language.keywords.sifre} :</h4>
                <input ref={passwordRef}  type="password" placeholder={xprops.project.language.keywords.sifreniziGiriniz} className="edits-login" value={password} onChange={handleChangePassword} onKeyPress={(e)=> e.key === 'Enter' && login()}  />
                <p className="sifremiUnuttumWrapper"><Link className="linkForgetPassword" to={xprops.project.language.routes.forgotPassword}>{xprops.project.language.keywords.sifremiUnuttum}</Link></p>
                <div className="loginSectionFooter">
                  <div className="loginSectionFooterLeft">
                  {xprops.project.language.keywords.hesabinizYokmu} <Link to={xprops.project.language.routes.signup} className="linkForgetPassword linkForgetPasswordSignUp">{xprops.project.language.keywords.kayitOl}</Link>
                  </div>
                  <div className="loginSectionFooterRight">
                    <button className="btnWeb lastExpertDetailBtn btnLogin" onClick={login}>{xprops.project.language.keywords.girisYap}</button>
                  </div>                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterNew/>
      
    </React.Fragment>
  );
}

export default GirisPage;